import icon from "src/decidim/icon";
import { dateToPicker, formatDate, displayDate, formatTime } from "src/decidim/datepicker/datepicker_functions";
import { dateKeyDownListener, dateBeforeInputListener } from "src/decidim/datepicker/datepicker_listeners";
import { getDictionary } from "src/decidim/i18n";
export default function generateDatePicker(input, row, formats) {
  const i18n = getDictionary("date.buttons");
  const datePickerI18n = getDictionary("wc_datepicker.labels");
  const showCloseButton = input.dataset.closeButton ? input.dataset.closeButton === "true" : true;
  const useCustomButtonStyling = input.dataset.useCustomButton ? input.dataset.useCustomButton === "true" : false;
  const dateColumn = document.createElement("div");
  dateColumn.setAttribute("class", "datepicker__date-column");
  const date = document.createElement("input");
  date.setAttribute("id", `${input.id}_date`);
  date.setAttribute("type", "text");
  const label = document.querySelector(`[for="${input.id}"]`);
  if (label) {
    label.setAttribute("for", `${input.id}_date`);
  }
  if (input.type === "date") {
    date.setAttribute("data-validator", "date");
    if (input.hasAttribute("data-date-input-aria-label")) {
      date.setAttribute("aria-label", input.getAttribute("data-date-input-aria-label"));
    }
  }
  if (input.hasAttribute("required")) {
    date.setAttribute("required", input.getAttribute("required"));
  }
  if (input.placeholder) {
    date.setAttribute("placeholder", input.placeholder);
  }
  const calendar = document.createElement("button");
  calendar.innerHTML = icon("calendar-line");
  calendar.setAttribute("class", "datepicker__calendar-button");
  calendar.setAttribute("type", "button");
  calendar.setAttribute("aria-label", datePickerI18n.openCalendar);
  calendar.setAttribute("aria-expanded", "false");
  calendar.setAttribute("aria-haspopup", "true");
  dateColumn.appendChild(date);
  dateColumn.appendChild(calendar);
  row.append(dateColumn);
  const datePickerContainer = document.createElement("div");
  datePickerContainer.setAttribute("class", "datepicker__container");
  datePickerContainer.style.display = "none";
  const datePicker = document.createElement("wc-datepicker");
  datePicker.setAttribute("id", `${date.id}_datepicker`);
  datePicker.setAttribute("locale", `${document.documentElement.getAttribute("lang") || "en"}`);
  datePicker.labels = datePickerI18n;
  datePicker.firstDayOfWeek = 1;
  calendar.setAttribute("aria-controls", datePicker.id);
  datePickerContainer.appendChild(datePicker);
  const checkCalendarPosition = (inputCalender, calendarContainer) => {
    const inputRect = inputCalender.getBoundingClientRect();
    const containerRect = document.documentElement.getBoundingClientRect();
    const calendarHeight = calendarContainer.offsetHeight;
    const spaceBelow = containerRect.bottom - inputRect.bottom;
    const containerIds = [
      "participatory_process_start_date_date",
      "conference_end_date_date",
      "assembly_creation_date_date"
    ];
    if (calendarHeight > spaceBelow) {
      calendarContainer.style.bottom = "100%";
      const container = containerIds.map((id) => document.getElementById(id)).find((el) => el);
      datePickerContainer.style.left = container ? `${container.offsetWidth - datePickerContainer.offsetWidth}px` : "0px";
    } else {
      calendarContainer.style.bottom = "auto";
    }
  };
  const addDatePickerTitle = () => {
    const title = input.dataset.datePickerTitle;
    if (title) {
      const datePickerTitle = document.createElement("p");
      datePickerTitle.innerText = title;
      datePickerTitle.setAttribute("class", "datepicker__title");
      const datePicker2 = datePickerContainer.querySelector(".wc-datepicker");
      datePicker2.insertBefore(datePickerTitle, datePicker2.firstChild);
      if (input.dataset.disableDynamicChange) {
        datePicker2.querySelectorAll("input, select").forEach((node) => node.setAttribute("data-disable-dynamic-change", ""));
      }
    }
  };
  const pickCalendar = document.createElement("button");
  pickCalendar.innerText = input.dataset.selectButtonLabel || i18n.select;
  if (useCustomButtonStyling) {
    pickCalendar.setAttribute("class", "datepicker__pick-calendar ow-button ow-button-primary");
  } else {
    pickCalendar.setAttribute("class", "datepicker__pick-calendar button button__secondary button__xs");
  }
  pickCalendar.setAttribute("disabled", true);
  pickCalendar.setAttribute("type", "button");
  const closeCalendar = document.createElement("button");
  closeCalendar.innerText = i18n.close;
  closeCalendar.setAttribute("class", "datepicker__close-calendar button button__transparent-secondary button__xs");
  closeCalendar.setAttribute("type", "button");
  dateColumn.appendChild(datePickerContainer);
  let prevDate = null;
  let defaultTime = input.getAttribute("default_time") || "00:00";
  const datePickerDisplay = (event) => {
    if (!dateColumn.contains(event.target)) {
      datePickerContainer.style.display = "none";
      calendar.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", datePickerDisplay);
    }
  };
  dateKeyDownListener(date);
  dateBeforeInputListener(date);
  date.addEventListener("paste", (event) => {
    event.preventDefault();
    const value = event.clipboardData.getData("text/plain");
    if (/^[0-9/.-]+$/.test(value)) {
      date.value = value.replaceAll(/[/.-]/g, formats.separator);
      if (input.type === "date") {
        input.value = `${formatDate(date.value, formats)}`;
      } else if (input.type === "datetime-local") {
        input.value = `${formatDate(date.value, formats)}T${formatTime(document.querySelector(`#${input.id}_time`).value, formats.time, input.id) || defaultTime}`;
      }
    }
  });
  date.addEventListener("focus", () => {
    datePickerContainer.style.display = "none";
    calendar.setAttribute("aria-expanded", "false");
  });
  date.addEventListener("keyup", () => {
    if (date.value.length === 10) {
      date.value = date.value.replaceAll(/[/.-]/g, formats.separator);
      prevDate = dateToPicker(date.value, formats);
      if (input.type === "date") {
        input.value = `${formatDate(date.value, formats)}`;
      } else if (input.type === "datetime-local") {
        input.value = `${formatDate(date.value, formats)}T${formatTime(document.querySelector(`#${input.id}_time`).value, formats.time, input.id) || defaultTime}`;
      }
    } else {
      input.value = "";
    }
  });
  let pickedDate = null;
  datePicker.addEventListener("selectDate", (event) => {
    pickCalendar.removeAttribute("disabled");
    pickedDate = event.detail;
  });
  pickCalendar.addEventListener("click", (event) => {
    event.preventDefault();
    date.value = displayDate(datePicker.value, formats);
    prevDate = pickedDate;
    if (input.type === "date") {
      input.value = `${pickedDate}`;
    } else if (input.type === "datetime-local") {
      input.value = `${pickedDate}T${formatTime(document.querySelector(`#${input.id}_time`).value, formats.time, input.id) || defaultTime}`;
    }
    datePickerContainer.style.display = "none";
    calendar.setAttribute("aria-expanded", "false");
    date.dispatchEvent(new Event("click", { bubbles: true }));
  });
  calendar.addEventListener("click", (event) => {
    event.preventDefault();
    if (input.value !== "") {
      if (input.type === "date") {
        prevDate = input.value;
      } else if (input.type === "datetime-local") {
        prevDate = input.value.split("T")[0];
      }
    }
    if (prevDate !== null && new Date(prevDate).toString() !== "Invalid Date") {
      datePicker.value = new Date(prevDate);
      datePicker.dispatchEvent(new Event("click", { bubbles: true }));
    }
    pickedDate = null;
    datePickerContainer.style.display = "block";
    calendar.setAttribute("aria-expanded", "true");
    const calendarRow = document.querySelector(`#${calendar.parentElement.parentElement.id}`);
    const inputCalendar = calendarRow && calendarRow.querySelector("input");
    if (inputCalendar) {
      checkCalendarPosition(inputCalendar, datePickerContainer);
    }
    document.addEventListener("click", datePickerDisplay);
  });
  const addCalendarActionButtons = (parentElement) => {
    const actionButtonContainer = document.createElement("div");
    actionButtonContainer.classList.add("datepicker__actions-container");
    actionButtonContainer.appendChild(pickCalendar);
    if (showCloseButton) {
      actionButtonContainer.appendChild(closeCalendar);
      closeCalendar.addEventListener("click", (event) => {
        event.preventDefault();
        datePickerContainer.style.display = "none";
        calendar.setAttribute("aria-expanded", "false");
      });
    }
    parentElement.appendChild(actionButtonContainer);
  };
  datePicker.addEventListener("wc-datepicker.ready", () => {
    const datePickerBody = datePickerContainer.querySelector(".wc-datepicker__body");
    addCalendarActionButtons(datePickerBody);
    addDatePickerTitle();
  }, { once: true });
  observerDatepickerInitialize(datePicker);
  return datePickerContainer;
}
function observerDatepickerInitialize(element) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        element.dispatchEvent(new Event("wc-datepicker.ready", { bubbles: true }));
        observer.disconnect();
      }
    }
  });
  observer.observe(element, { childList: true, subtree: true });
}
